<header class="padding-top-bottom-15 bg-light-2" *ngIf="!showNavBar">
  <div class="content-wrap flex row wrap y-items-center space-between full-height">
    <h1 class="logo-title absolute top-0 left-0 block">
      <ng-container *ngIf="sys === 'wt'">
        <ng-container *ngIf="('lang' | translate) === 'en'"> Wintrillions.com </ng-container>
        <ng-container *ngIf="('lang' | translate) === 'es'"> Trillonario.com </ng-container>
        <ng-container *ngIf="('lang' | translate)  === 'pt'"> Trilhardario.com </ng-container>
      </ng-container>
      <ng-container *ngIf="sys === 'ltk'">
        <ng-container *ngIf="('lang' | translate) != 'pt'"> Lottokings.com </ng-container>
        <ng-container *ngIf="('lang' | translate)  === 'pt'"> LottoSena.com </ng-container>
      </ng-container>
    </h1>
    <ng-container *ngIf="sys === 'wt'">
      <ng-container *ngIf="('lang' | translate) === 'en'">
        <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/en/logo.png'" alt="logo" />
      </ng-container>
      <ng-container *ngIf="('lang' | translate) === 'es'">
        <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/es/logo.png'" alt="logo" />
      </ng-container>
      <ng-container *ngIf="('lang' | translate) === 'pt'">
        <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/pt/logo.png'" alt="logo" />
      </ng-container>
    </ng-container>
    <ng-container *ngIf="sys === 'ltk'">
      <ng-container *ngIf="('lang' | translate) != 'pt'">
        <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/default/logo.png'" alt="logo" />
      </ng-container>
      <ng-container *ngIf="('lang' | translate)  === 'pt'">
        <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/pt/logo.png'" alt="logo" />
      </ng-container>
    </ng-container>

    <h4 class="slogan">
      <ng-container *ngIf="('lang'| translate)  === 'en'"> More games, more chances, more fun </ng-container>
      <ng-container *ngIf="('lang' | translate) === 'es'"> Más juegos, más chances, más diversión </ng-container>
      <ng-container *ngIf="('lang' | translate) === 'pt'"> Mais jogos, mais chances, mais diversão </ng-container>
    </h4>
  </div>
</header>
